// Fabric-only group names for chrome / scaffold objects users never
// select. Domain-facing sentinels (grid, cut shape wrapper) live in
// @/domain/selection/reservedSelectionIds and are imported directly
// by their consumers.

const CUTTING_MASK_NAME = 'cuttingPathMask';
const CUTTING_OUTLINE_NAME = 'cuttingPathOutline';
const LOCKED_FOREGROUND_GROUP_NAME = 'lockedForegroundObjectGroup';
const WORKING_ZONE_NAME = 'workingZoneGroup';
const BACKGROUND_MASK_NAME = 'backgroundMask';

export { BACKGROUND_MASK_NAME, CUTTING_MASK_NAME, CUTTING_OUTLINE_NAME, LOCKED_FOREGROUND_GROUP_NAME, WORKING_ZONE_NAME };
